import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components/button';
import { DiamondIcon } from '@shared/components/icons';
import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts/modal-context';

import { ModalName } from '../types';
import * as Styled from './jackpot-info-modal.styled';

const JackpotInfoModal = () => {
  const { t } = useTranslation('coin_race');
  const { isModalOpen, closeModal } = useModals();

  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <Modal isOpen={isModalOpen(ModalName.JACKPOT_INFO)} title={
      <Styled.Title>
        <DiamondIcon />
        <span>{t('jackpot_info.title')}</span>
      </Styled.Title>
    } closeModal={closeModal}>
      <Styled.Wrapper>
        <Styled.Content>
          <Styled.Description>
            <ul>
              <li>
                {t('jackpot_info.description')}
              </li>
              <li>
                {t('jackpot_info.description2')}
              </li>
              <li>
                {t('jackpot_info.description3')}
              </li>
              <li>
                {t('jackpot_info.description4')}
              </li>
            </ul>
          </Styled.Description>
        </Styled.Content>

        <Styled.Footer>
          <Button color='dark' onClick={handleCloseModal}>
            {t('close')}
          </Button>
        </Styled.Footer>
      </Styled.Wrapper>
    </Modal>
  );
};

export default JackpotInfoModal;

